import {
  ModalBackdropStyled,
  SideSheetHeader,
  SideSheetClose,
  Box,
  Button,
  ButtonAppearance,
  TabList,
  ButtonProps,
  ButtonSize,
} from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { FC } from 'react';
export const DrawerBackdropStyled = styled(ModalBackdropStyled)`
  position: absolute;
  left: 0;
  z-index: 2;
`;
export const DrawerOuterStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 525px;
`;
export const DrawerHeaderStyled = styled(SideSheetHeader)`
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.white};
      color: ${theme.colors.black};
      padding: ${theme.spacings[700]} ${theme.spacings[500]};
    `}
`;

export const DrawerCloseStyled = styled(SideSheetClose).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) =>
    css`
      color: ${theme.colors.blue[800]};
      border: none;
      margin-top: ${theme.spacings[500]};
    `}
`;

export const ButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.SECONDARY,
})`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  border: none;
  margin-top: auto;
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.white};
      font-weight: ${theme.fontWeights['600']};
      color: ${theme.colors.bechtel.blue['800']};
    `}
`;

export const ButtonBox = styled(Box).attrs({
  justifyContent: { sm: 'flex-end' },
})`
  ${ButtonStyled} {
    font-weight: ${({ theme }) => theme.fontWeights[600]};
    padding: 0 ${({ theme }) => theme.spacings[600]};
  }
`;

export const TabListStyled = styled(TabList)`
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
  z-index: 1;
`;

export interface TabButtonProps extends ButtonProps {
  isSelected: boolean;
}

export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  border: none;
  border-radius: 0;
  position: relative;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['400']};

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.isSelected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      &::after {
        opacity: 1;
      }
    `};
`;
